export default __webpack_public_path__ + "static/funders-ddcf-3492a181b416710bf27ddc3778b8fad9.png";